import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { BaseServiceAccountResponseSchema } from './base';
export const ServiceAccountItemSchema = BaseServiceAccountResponseSchema.extend({
    serviceIdentityCount: z.number().int().nonnegative(),
});
export const ListServiceAccountResponseSchema = z.object({
    items: z.array(ServiceAccountItemSchema),
});
export class ListServiceAccountResponseDto extends createZodDto(ListServiceAccountResponseSchema) {
}
